import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MaterialUIControllerProvider } from './context/contexts';
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux';
import reduxStore from './stateManagement/reduxStore';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={reduxStore}>
      <Router>
        <MaterialUIControllerProvider>
          <App />
        </MaterialUIControllerProvider>
      </Router>
    </Provider>
  </React.StrictMode>
);
